export const headerManager = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: 'updateHeaderProperties',
      },
    },
    updateHeaderProperties: {
      invoke: {
        src: 'setHeaderProperties',
        onDone: {
          target: 'idle',
          actions: {
            type: 'batchLayoutOperations',
            data: '$event.data.updates',
            meta: {
              selectors: ['$action.data'],
            },
          },
        },
      },
    },
  },
};
